import { DeleteDisplayGroupRole, DeleteDisplayGroupRoleVariables } from './__generated__/DeleteDisplayGroupRole'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

export const DELETE_DISPLAY_GROUP_ROLE_MUTATION = gql`
  mutation DeleteDisplayGroupRole($input: DeleteDisplayGroupRoleInputV2!) {
    deleteDisplayGroupRoleV2(input: $input) {
      ... on DisplayGroupRoleErrorV2 {
        type
        error
      }
      ... on DisplayGroupRoleV2 {
        id
      }
    }
  }
`

export const useDeleteDisplayGroupRole = () => {
  return useMutation<DeleteDisplayGroupRole, DeleteDisplayGroupRoleVariables>(DELETE_DISPLAY_GROUP_ROLE_MUTATION)
}
